export default "__VITE_ASSET__CNKj8gEQ__"